<div
    class="layout-edit-node relative w-full"
    [class.layout-edit-node--selected]="isSelected()"
    [class.layout-edit-node--overlay-hidden]="isOverlayHidden()"
    [class.layout-edit-node--structure]="isStructureNode()"
    [class.layout-edit-node--leaf]="isLeaf()"
    [class.layout-edit-node--empty-group]="isEmptyGroup()"
    [attr.data-layout-node-id]="layoutNodeId()"
    [attr.data-overlay-hidden]="isOverlayHidden() ? 'true' : null"
    [attr.data-layout-selected]="isSelected() ? 'true' : null"
    data-testid="layout-edit-node"
    (click)="onSelect($event)"
    (contextmenu)="onContextMenu($event)"
>
    @if (isSelected()) {
        <div
            class="layout-edit-move-chrome"
            data-testid="layout-edit-move-chrome"
            (click)="$event.stopPropagation()"
        >
            <p-button
                type="button"
                icon="fa-solid fa-arrow-up"
                severity="secondary"
                size="small"
                [disabled]="treeLocked() || !canMoveUp()"
                [pTooltip]="'layout-edit.move-up' | translate"
                data-testid="layout-edit-move-up"
                (onClick)="onMoveUp($event)"
            />
            <p-button
                type="button"
                icon="fa-solid fa-arrow-down"
                severity="secondary"
                size="small"
                [disabled]="treeLocked() || !canMoveDown()"
                [pTooltip]="'layout-edit.move-down' | translate"
                data-testid="layout-edit-move-down"
                (onClick)="onMoveDown($event)"
            />
            <p-button
                type="button"
                icon="fa-solid fa-arrow-right"
                severity="secondary"
                size="small"
                [pTooltip]="'layout-edit.move-to' | translate"
                [disabled]="treeLocked() || !canMoveTo()"
                data-testid="layout-edit-move-to"
                (onClick)="onMoveTo($event)"
            />
            <p-button
                type="button"
                icon="fa-solid fa-eye-slash"
                [severity]="isOverlayHidden() ? 'primary' : 'secondary'"
                [disabled]="treeLocked()"
                size="small"
                [pTooltip]="'layout-edit.overlay-hide' | translate"
                data-testid="layout-edit-overlay-hide"
                (onClick)="onToggleOverlayHide($event)"
            />
            <p-button
                type="button"
                icon="fa-solid fa-trash"
                severity="secondary"
                size="small"
                [disabled]="treeLocked()"
                [pTooltip]="'layout-edit.remove' | translate"
                data-testid="layout-edit-remove"
                (onClick)="onRemove($event)"
            />
        </div>
    }
    <div class="layout-edit-field-slot w-full min-w-0">
        <ng-container #fieldComponent></ng-container>
        @if (isEmptyGroup()) {
            <p
                class="layout-edit-empty-group text-surface-500 m-0 px-2 py-3 text-sm"
                data-testid="layout-edit-empty-group"
            >
                {{ 'layout-edit.empty-group' | translate }}
            </p>
        }
    </div>
</div>
